module.exports = "/_next/static/images/findAll-932f20c62315202d6f11c473451b16d3.png.webp";